import {CLEAR} from "./user";

export const AUTHENTICATED = 'session/AUTHENTICATED'
const initialState = {
    authenticated:false,
    ready:false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case AUTHENTICATED:
            let nstate = {
                ...state,
                authenticated:action.data,
                ready:true
            };

            return nstate;
        case CLEAR:
            return initialState;
        default:
            return state
    }
}






// WEBPACK FOOTER //
// ./src/modules/session.js